var path = require('path');

function rebaseToFrom(option) {
  return option ? path.resolve(option) : process.cwd();
}

module.exports = rebaseToFrom;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/options/rebase-to.js
// module id = 2313
// module chunks = 0